import React from "react";
import { Button, Tooltip } from "@mui/material";

const GenericActionButton = ({
  tooltipText,
  label,
  onClick,
  icon,
  disabled = false,
  color = "secondary",
  variant = "contained",
  size = "small",
  sx = {},
  ...props
}) => (
    <Tooltip title={tooltipText} arrow>
  <Button
    variant={variant}
    size={size}
    color={color}
    onClick={onClick}
    disabled={disabled}
    sx={{ textTransform: "none",  ...sx }}
    startIcon={icon}
    {...props}
  >
    {label}
  </Button>
  </Tooltip>
);

export default GenericActionButton;